/*
 * 検定バナー ABCテスト（2026-10-10〜）
 * 訪問者ごとに A/B/C をランダムで1/3ずつ割り当て（同じ人には毎回同じ案）、
 * バナーの表示（半分以上が1秒以上見えた）とクリックを BATHLIER HUB へ送る。
 * 個人情報は送らない。vid はブラウザに保存したランダムな文字列。
 * 設定は window.KABC（snippets/kentei-abc.liquid）で渡す。
 * 確認用：URLに ?kabc=A|B|C を付けると、その案を表示する（割り当ては変えない）。
 */
(function () {
  var C = window.KABC;
  if (!C || !C.img) return;

  var LS = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };
  var ok = function (v) { return /^[ABC]$/.test(v || ''); };
  var qs = new URLSearchParams(location.search);

  // 案の割り当て
  var V = LS.get('kabc_v');
  if (!ok(V)) { V = 'ABC'.charAt(Math.floor(Math.random() * 3)); LS.set('kabc_v', V); }
  var forced = qs.get('kabc');
  if (ok(forced)) V = forced;

  // 匿名ID
  var vid = LS.get('kabc_vid');
  if (!vid || !/^[A-Za-z0-9_-]{8,64}$/.test(vid)) {
    vid = (window.crypto && crypto.randomUUID ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2))).replace(/[^A-Za-z0-9_-]/g, '');
    LS.set('kabc_vid', vid);
  }

  var mq = window.matchMedia('(max-width: 749px)');
  var device = mq.matches ? 'sp' : 'pc';
  var I = C.img[V];
  var ALT = C.alt[V];

  function href(slot) {
    return C.href + '?utm_source=' + C.site + '&utm_medium=banner&utm_campaign=kentei_abc_2026_10&utm_content=kentei_' + V + '_' + slot + '&kabc=' + V;
  }

  // ---- 送信 ----
  var queue = [];
  var bot = !!navigator.webdriver;
  var path = ((C.preview ? '/__test__' : '') + location.pathname).slice(0, 200);
  function flush() {
    if (!queue.length) return;
    var ev = queue.splice(0, 20);
    if (bot) return;
    var body = JSON.stringify({ site: C.site, vid: vid, device: device, path: path, ev: ev });
    try {
      fetch(C.endpoint, { method: 'POST', mode: 'cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body }).catch(function () {});
    } catch (e) {}
  }
  setInterval(flush, 4000);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  window.addEventListener('pagehide', flush);

  // ---- 表示とクリックの判定 ----
  var watched = [];
  var seen = {};
  function register(el, slot, extra) {
    if (!el) return;
    watched.push({ el: el, slot: slot, extra: extra, hits: 0 });
    el.addEventListener('click', function () {
      queue.push({ v: V, t: 'click', s: slot });
      LS.set('kabc_clicked', V);
      flush();
    }, true);
  }
  function visibleHalf(el) {
    if (!el.offsetWidth || !el.offsetHeight) return false;
    var r = el.getBoundingClientRect();
    var h = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    var w = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0);
    return h > 0 && w > 0 && (h * w) / (r.height * r.width) >= 0.5;
  }
  setInterval(function () {
    if (document.visibilityState !== 'visible') return;
    for (var i = 0; i < watched.length; i++) {
      var w = watched[i];
      if (seen[w.slot]) continue;
      var on = visibleHalf(w.el) && (!w.extra || w.extra(w.el));
      w.hits = on ? w.hits + 1 : 0;
      if (w.hits >= 2) { // 0.5秒ごとに確認し、2回続けて見えていれば（=約1秒）表示とみなす
        seen[w.slot] = 1;
        queue.push({ v: V, t: 'view', s: w.slot });
      }
    }
  }, 500);

  // ---- 置き場所：data-kabc-slot の枠に画像バナーを入れる ----
  function picture(pcKey, spKey) {
    return '<picture><source media="(max-width: 749px)" srcset="' + I[spKey] + '">' +
      '<img src="' + I[pcKey] + '" alt="' + ALT + '" loading="lazy" style="display:block;width:100%;height:auto"></picture>';
  }
  var mounts = document.querySelectorAll('[data-kabc-slot]');
  for (var m = 0; m < mounts.length; m++) {
    var box = mounts[m];
    var slot = box.getAttribute('data-kabc-slot');
    var a = document.createElement('a');
    a.href = href(slot);
    a.setAttribute('aria-label', ALT);
    a.style.display = 'block';
    a.innerHTML = picture(box.getAttribute('data-kabc-pc') || 'pc', box.getAttribute('data-kabc-sp') || 'sp');
    box.innerHTML = '';
    box.appendChild(a);
    register(a, slot);
  }

  if (C.site === 'shop') {
    // TOPスライダー（PC 2:1・スマホ 3:5）
    var slides = document.querySelectorAll('[id*="__newslide"] a[href*="kentei.bathlier.com"]');
    for (var s = 0; s < slides.length; s++) {
      var sl = slides[s];
      sl.href = href('top_slider');
      var pcImg = sl.querySelector('img.pc_onry'), spImg = sl.querySelector('img.sp_onry');
      if (pcImg) { pcImg.src = I.wide; pcImg.alt = ALT; }
      if (spImg) { spImg.src = I.sp35; spImg.alt = ALT; }
      register(sl, 'top_slider', function (el) {
        var sw = el.closest('.swiper-slide');
        return !sw || sw.classList.contains('swiper-slide-active');
      });
    }

    // TOP固定バナー（背景画像 PC 3:1・スマホ 9:16、全面がリンク）
    var rich = document.querySelectorAll('[id*="__rich_text"]');
    for (var r = 0; r < rich.length; r++) {
      var btn = rich[r].querySelector('a[href*="kentei.bathlier.com"]');
      if (!btn) continue;
      var pw = rich[r].querySelector('.page-width');
      btn.href = href('top_fixed');
      btn.setAttribute('aria-label', ALT);
      if (pw) {
        var setBg = function (el) { return function () { el.style.backgroundImage = 'url("' + (mq.matches ? I.full : I.pc) + '")'; }; }(pw);
        setBg();
        if (mq.addEventListener) mq.addEventListener('change', setBg);
        register(pw, 'top_fixed');
      }
    }

    // TOP中段（12:7）
    var black = document.querySelectorAll('[id*="__blackcontent"] a[href*="kentei.bathlier.com"]');
    var firstBlack = null;
    for (var b = 0; b < black.length; b++) {
      black[b].href = href('top_middle');
      var bi = black[b].querySelector('img');
      if (bi && !firstBlack) { bi.src = I.card; bi.alt = ALT; firstBlack = black[b]; }
    }
    if (firstBlack) register(firstBlack, 'top_middle');

    // フッター（12:7）
    var foots = document.querySelectorAll('#shopify-section-footer-promotions a[href*="kentei.bathlier.com"]');
    var firstFoot = null;
    for (var f = 0; f < foots.length; f++) {
      foots[f].href = href('footer');
      var fi = foots[f].querySelector('img');
      if (fi && !firstFoot) {
        fi.removeAttribute('data-src'); fi.removeAttribute('data-widths'); fi.removeAttribute('data-sizes'); fi.removeAttribute('srcset');
        fi.classList.remove('lazyload'); fi.classList.add('lazyloaded');
        fi.src = I.card; fi.alt = ALT;
        firstFoot = foots[f];
      }
    }
    if (firstFoot) register(firstFoot, 'footer');

    // 申込の記録：検定サイトから案を引き継いで来た人、またはバナーをクリックした人の案を、
    // 検定商品のページでカートの属性に入れる（注文に残る）
    var from = qs.get('kabc_from');
    if (ok(from)) LS.set('kabc_attr', from);
    var attr = LS.get('kabc_attr') || LS.get('kabc_clicked');
    if (ok(attr) && /\/products\/sommelier-/.test(location.pathname)) {
      try {
        if (!sessionStorage.getItem('kabc_cart_' + attr)) {
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { kentei_abc: attr } }) })
            .then(function () { try { sessionStorage.setItem('kabc_cart_' + attr, '1'); } catch (e) {} })
            .catch(function () {});
        }
      } catch (e) {}
    }
  }
})();
